<template>
    <div class="content-container">
        <div class='title'>
            {{$t('outils.compteur.step.one.title.partenaire')}}
            <ReglePastille cle="outils.etape1Obligatoire" />
        </div>
        <div class='margin-top-8px'>{{$t('outils.compteur.step.one.two.subtitle.check')}}</div>

        <div class='input-container'>
            <div>{{$t('outils.compteur.step.one.raison.sociale')}}</div>
            <input class='text-input' v-model='raisonSociale'>
        </div>

        <div class='input-container'>
            <div>{{$t('outils.compteur.step.one.nom.commercial')}}</div>
            <input class='text-input' v-model='nomCommercial'>
        </div>

        <div class='input-container'>
            <div>{{$t('outils.compteur.step.one.numero.identification')}}</div>
            <input class='text-input' v-model='numeroIdentification'>
        </div>

        <div class='input-container'>
            <div>{{$t('outils.compteur.step.one.adresse.postale')}}</div>
            <input class='text-input' v-model='adressePostale'>
        </div>

        <div class='input-container'>
            <div>{{$t('outils.compteur.step.one.code.postal')}}</div>
            <input class='text-input' v-model='codePostal' type='number' @keypress="disableNegatif($event)" min='0'>
        </div>

        <div class='input-container'>
            <div>{{$t('outils.compteur.step.one.ville')}}</div>
            <input class='text-input' v-model='ville'>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { COMPTEUR } from '@/modules/Outils/store/mutation-types';
import ReglePastille from '@/components/regles/ReglePastille.vue';

export default defineComponent({
    emits: ['next'],
    components: { ReglePastille },
    methods: {
        disableNegatif(event: any): boolean{
            if(event.key == '-' || event.key == ',' || event.key == '.' || event.key === 'e'){
                event.preventDefault();
                return false;
            }else{
                return true;
            }
        }
    },
    computed: {
        raisonSociale: {
            get(): string {
                return this.$store.getters.getRaisonSociale;
            },
            set(value: string) {
                this.$store.commit(COMPTEUR.SET_RAISON_SOCIALE, value.trim());
            },
        },
        nomCommercial: {
            get(): string {
                return this.$store.getters.getNomCommercial;
            },
            set(value: string) {
                this.$store.commit(COMPTEUR.SET_NOM_COMMERCIAL, value.trim());
            },
        },
        numeroIdentification: {
            get(): string {
                return this.$store.getters.getNumeroIdentification;
            },
            set(value: string) {
                this.$store.commit(COMPTEUR.SET_NUMERO_IDENTIFICATION, value.trim());
            },
        },
        adressePostale: {
            get(): string {
                return this.$store.getters.getAdressePostale;
            },
            set(value: string) {
                this.$store.commit(COMPTEUR.SET_ADRESSE_POSTALE, value.trim());
            },
        },
        codePostal: {
            get(): number | undefined {
                return this.$store.getters.getCodePostal;
            },
            set(value: string) {
                this.$store.commit(COMPTEUR.SET_CODE_POSTAL, value);
            },
        },
        ville: {
            get(): string {
                return this.$store.getters.getVille;
            },
            set(value: string) {
                this.$store.commit(COMPTEUR.SET_VILLE, value.trim());
            },
        },
    },

});
</script>

<style scoped>
.content-container {
    margin-top: 8px;
    padding: 16px 24px;
    overflow: auto;
    background-color: #fff;
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.14), 0 1px 5px rgba(0, 0, 0, 0.12);
    border-radius: 6px;
}
.title {
    color: var(--dark-blue);
    font-weight: var(--font-weight-medium);
    font-size: var(--font-size-low-large);
}
.margin-top-8px {
    margin-top: 8px;
}
.input-container {
    margin-top: 16px;
}
.text-input {
    width: 30%;
    height: 35px;
    margin-top: 5px;
}
</style>
